module.exports = __webpack_public_path__ + "static/7-c6a12d738fbff0ea00b9a4e814611eeb.jpeg";